import { CropCoordinates } from '../types'

export const calcDefaultCoordinates = ({
  aspectRatio,
  imgHeight,
  imgWidth,
  zoom = 0,
  offsetLeft = 0.5,
  offsetTop = 0.5,
}: {
  aspectRatio: number | undefined
  imgHeight: number
  imgWidth: number
  zoom?: number
  offsetLeft?: number
  offsetTop?: number
}): CropCoordinates => {
  if (!aspectRatio) {
    return { crop_x: 0, crop_y: 0, crop_w: imgWidth, crop_h: imgHeight }
  }

  let width = Math.min(Math.floor(imgHeight * aspectRatio), imgWidth)
  let height = Math.min(Math.floor(imgWidth / aspectRatio), imgHeight)

  width -= Math.round(width * zoom)
  height -= Math.round(height * zoom)

  return {
    crop_x: Math.floor((imgWidth - width) * offsetLeft),
    crop_y: Math.floor((imgHeight - height) * offsetTop),
    crop_w: width,
    crop_h: height,
  }
}
